export const ROOT_PATH = '/'
export const SIGN_IN_PATH = '/sign-in/'
